var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_354_5585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16H46.5C47.327 16 48 16.673 48 17.5V25.5C48 26.327 47.327 27 46.5 27H17.5C16.673 27 16 26.327 16 25.5V17.5C16 16.673 16.673 16 17.5 16ZM17 25.5C17 25.775 17.225 26 17.5 26H46.5C46.775 26 47 25.775 47 25.5V17.5C47 17.225 46.775 17 46.5 17H17.5C17.225 17 17 17.225 17 17.5V25.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28.5C16.776 28.5 17 28.724 17 29V46.5C17 46.775 17.225 47 17.5 47H46.5C46.775 47 47 46.775 47 46.5V29C47 28.724 47.224 28.5 47.5 28.5C47.776 28.5 48 28.724 48 29V46.5C48 47.327 47.327 48 46.5 48H17.5C16.673 48 16 47.327 16 46.5V29C16 28.724 16.224 28.5 16.5 28.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 43C33.673 43 33 42.327 33 41.5V33.5C33 32.673 33.673 32 34.5 32H42.5C43.327 32 44 32.673 44 33.5V41.5C44 42.327 43.327 43 42.5 43H34.5ZM43 41.5V33.5C43 33.225 42.775 33 42.5 33H34.5C34.225 33 34 33.225 34 33.5V41.5C34 41.775 34.225 42 34.5 42H42.5C42.775 42 43 41.775 43 41.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 34H21C20.724 34 20.5 33.776 20.5 33.5C20.5 33.224 20.724 33 21 33H30C30.276 33 30.5 33.224 30.5 33.5C30.5 33.776 30.276 34 30 34Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 38H21C20.724 38 20.5 37.776 20.5 37.5C20.5 37.224 20.724 37 21 37H30C30.276 37 30.5 37.224 30.5 37.5C30.5 37.776 30.276 38 30 38Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 42H21C20.724 42 20.5 41.776 20.5 41.5C20.5 41.224 20.724 41 21 41H30C30.276 41 30.5 41.224 30.5 41.5C30.5 41.776 30.276 42 30 42Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_354_5585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 48 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.ec19dbb8a9d48b75b359a3b43e583790.svg";
export { ForwardRef as ReactComponent };